<template>
  <PageWrapper :isLoading="isLoading" hasFilters @submitFilters="handleSubmitFilters">
    <template #title>لیست وفاداری کاربران</template>

    <template #titleBtn>
      <BButton variant="success" @click="openCreateModal">افزودن کاربر</BButton>
    </template>

    <template #filters>
      <v-select
          class="filters-width w-24"
          v-model="filters.levelLoyaltyId"
          :options="levelOptions"
          :reduce="(level) => level.id"
          label="name"
          placeholder="فیلتر سطح..."
          :loading="levelsLoading"
          :disabled="levelsLoading || isLoading"
          dir="rtl"
          clearable
      >
        <template #option="{ name, avatar, priority, discount }">
          <div class="lvl-option">
            <div class="lvl-badge" :class="getAvatarClass(avatar)">
              <img v-if="getAvatarMeta(avatar).src" :src="getAvatarMeta(avatar).src" alt="" class="lvl-img" />
              <feather-icon v-else :icon="getAvatarMeta(avatar).icon" size="16" />
            </div>

            <div class="lvl-option__info">
              <div class="lvl-option__name">{{ name }}</div>
            </div>
          </div>
        </template>

        <template #selected-option="{ name, avatar }">
          <div class="lvl-selected">
            <div class="lvl-badge lvl-badge--sm" :class="getAvatarClass(avatar)">
              <img
                  v-if="getAvatarMeta(avatar).src"
                  :src="getAvatarMeta(avatar).src"
                  alt=""
                  class="lvl-img lvl-img--sm"
              />
              <feather-icon v-else :icon="getAvatarMeta(avatar).icon" size="14" />
            </div>
            <span class="lvl-selected__name">{{ name }}</span>
          </div>
        </template>

        <template #no-options>هیچ سطحی یافت نشد</template>
      </v-select>

      <SearchInput
          class="filters-width w-24"
          inputLabel="جستجوی نام و شماره تماس کاربر"
          inputPlaceholder="جستجو..."
          v-model="filters.search"
      />
    </template>

    <CustomTable
        :pageNumber="filters.pageNumber"
        :count="filters.count"
        :totalCount="totalRows"
        :tableColumns="tableColumns"
        :tableItems="tableRows"
        @changePage="handleChangePage"
    >
      <template #levelAvatar="data">
        <div class="avatar-cell">
          <LevelAvatarBadge :avatarKey="data.item.levelAvatar" />
          <div class="avatar-text">
            <div class="avatar-text__title">{{ getAvatarMeta(data.item.levelAvatar).label }}</div>
            <div class="avatar-text__subtitle">{{ data.item.levelName }}</div>
          </div>
        </div>
      </template>

      <template #targetDate="data">
        <span style="white-space: nowrap">{{ formatYearMonth(data.item.targetDate) }}</span>
      </template>

      <template #scheduleTotal="data">
        <div style="white-space: nowrap">{{ formatNumber(data.item.scheduleTotal) }} دقیقه</div>
      </template>

      <template #groupClassTotal="data">
        <div style="white-space: nowrap">{{ formatNumber(data.item.groupClassTotal) }} دقیقه</div>
      </template>

      <template #termicClassTotal="data">
        <div style="white-space: nowrap">{{ formatNumber(data.item.termicClassTotal) }} دقیقه</div>
      </template>

      <template #supportTotal="data">
        <div style="white-space: nowrap">{{ formatNumber(data.item.supportTotal) }} دقیقه</div>
      </template>

      <template #allTime="data">
        <BBadge variant="dark" style="white-space: nowrap">{{ formatNumber(data.item.allTime) }} دقیقه</BBadge>
      </template>

      <template #actions="data">
        <div class="actions">
          <b-button
              variant="light"
              class="icon-btn"
              @click="openHistoryPreview(data.item)"
              v-b-tooltip.hover
              title="مشاهده تاریخچه کاربر"
          >
            <feather-icon icon="EyeIcon" size="16" />
          </b-button>

          <b-button
              variant="light"
              class="icon-btn"
              @click="openUpdateLevelModal(data.item)"
              v-b-tooltip.hover
              title="ویرایش سطح"
          >
            <feather-icon icon="EditIcon" size="16" />
          </b-button>

          <b-button
              variant="light"
              class="icon-btn"
              :disabled="!isValidUserId(data.item.levelLoyaltUserId)"
              @click="goToDetailPage(data.item.levelLoyaltUserId)"
              v-b-tooltip.hover
              title="گزارش روزانه وفاداری کاربران"
          >
            <feather-icon icon="ChevronLeftIcon" size="16" />
          </b-button>
        </div>
      </template>

      <template #table-busy>
        <div class="text-center my-2">در حال دریافت اطلاعات...</div>
      </template>
    </CustomTable>

    <HistoryPreviewModal v-model="showHistoryModal" :userData="selectedUser" :histories="userHistories" />

    <UpdateLevelModal v-model="showUpdateLevelModal" :userData="selectedUserData" @updated="handleLevelUpdated" />

    <CreateUserLoyaltyDialog
        :submitting="isCreating"
        :users="usersList"
        :levels="levelsList"
        @cancel="closeCreateModal"
        @submit="submitCreate"
        @userSearch="handleUserSearch"
    />
  </PageWrapper>
</template>

<script>
import { GetListLevelLoyaltUser, List as GetLevelList, CreatelevelLoyaltUserbyAdmin } from "@/libs/Api/LevelLoyalty";
import { GetAllUsersList } from "@/libs/Api/Users";
import { BButton, BBadge, VBTooltip } from "bootstrap-vue";
import vSelect from "vue-select";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import UpdateLevelModal from "@core/components/loyalty/UpdateLevelModal.vue";
import CreateUserLoyaltyDialog from "@core/components/loyalty/CreateUserLoyaltyDialog.vue";
import LevelAvatarBadge from "@core/components/loyalty/LevelAvatarBadge.vue";
import HistoryPreviewModal from "@core/components/loyalty/UserLoyaltyPreviewDialog.vue";
import { getLevelAvatarMeta } from "@core/utils/levelAvatars";

export default {
  name: "ListLevelLoyaltUser",
  components: {
    PageWrapper,
    CustomTable,
    SearchInput,
    UpdateLevelModal,
    CreateUserLoyaltyDialog,
    LevelAvatarBadge,
    HistoryPreviewModal,
    BButton,
    BBadge,
    vSelect
  },
  directives: { "b-tooltip": VBTooltip },
  data() {
    return {
      isLoading: false,
      totalRows: 0,
      rawItems: [],
      filters: { pageNumber: 1, count: 10, search: "", levelLoyaltyId: 0 },
      searchTimeout: null,
      usersSearchTimeout: null,
      showHistoryModal: false,
      showUpdateLevelModal: false,
      selectedUserHistory: null,
      selectedUserData: null,
      userHistories: [],
      isCreating: false,
      levelsList: [],
      usersList: [],
      levelOptions: [],
      levelsLoading: false,
      tableColumns: [
        { label: "نام کاربر", key: "fullName" },
        { label: "نام سطح", key: "levelName" },
        { label: "شماره تماس", key: "mobile" },
        { label: "تاریخ", key: "targetDate" },
        { label: "کلاس ساعتی", key: "scheduleTotal" },
        { label: "کلاس گروهی", key: "groupClassTotal" },
        { label: "کلاس ترمیک", key: "termicClassTotal" },
        { label: "پشتیبانی", key: "supportTotal" },
        { label: "کل فعالیت", key: "allTime" },
        { label: "عملیات", key: "actions", thStyle: { width: "160px" } }
      ]
    };
  },
  computed: {
    tableRows() {
      return this.rawItems.map((item, index) => ({
        rowKey: `${item.levelLoyaltUserId}-${item.userId}-${item.targetDate}-${index}`,
        ...item,
        histories: item.histories || []
      }));
    },
    selectedUser() {
      return this.selectedUserHistory;
    }
  },
  watch: {
    "filters.search": function () {
      this.scheduleSearch();
    },
    "filters.levelLoyaltyId": function () {
      this.filters.pageNumber = 1;
      this.fetchList();
    }
  },
  mounted() {
    this.fetchList();
    this.loadLevelsForFilter();
  },
  beforeDestroy() {
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    if (this.usersSearchTimeout) clearTimeout(this.usersSearchTimeout);
  },
  methods: {
    getAvatarMeta(key) {
      return getLevelAvatarMeta(key);
    },
    getAvatarClass(avatar) {
      const meta = this.getAvatarMeta(avatar);
      return meta?.colorClass || "c--neutral";
    },
    scheduleSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.filters.pageNumber = 1;
        this.fetchList();
      }, 500);
    },
    handleSubmitFilters() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.filters.pageNumber = 1;
      this.fetchList();
    },
    handleChangePage(pageNumber) {
      const next = Math.max(1, Number(pageNumber || 1));
      if (next === this.filters.pageNumber) return;
      this.filters.pageNumber = next;
      this.fetchList();
    },
    formatNumber(value) {
      const num = Number(value || 0);
      try {
        return new Intl.NumberFormat("fa-IR").format(num);
      } catch {
        return String(num);
      }
    },
    formatYearMonth(isoString) {
      if (!isoString) return "—";
      try {
        const date = new Date(isoString);
        if (isNaN(date.getTime())) return "—";
        return date.toLocaleDateString("fa-IR", { year: "numeric", month: "long" });
      } catch {
        return String(isoString).slice(0, 7);
      }
    },
    normalizeUserId(userId) {
      const id = parseInt(String(userId || "0"), 10);
      return Number.isFinite(id) && id > 0 ? id : 0;
    },
    isValidUserId(userId) {
      return this.normalizeUserId(userId) > 0;
    },
    showToast(variant, title, text) {
      this.$toast({
        component: ToastificationContent,
        position: "bottom-center",
        props: { title, text, icon: "", variant }
      });
    },
    async loadLevelsForFilter() {
      try {
        this.levelsLoading = true;
        const request = new GetLevelList(this);
        request.setRequestParam({ pageNumber: 1, count: 100 });
        const response = await new Promise((resolve, reject) => request.send(resolve, reject));
        const rows = response?.data?.data;
        this.levelOptions = Array.isArray(rows)
            ? rows.map((x) => ({
              id: Number(x.id || 0),
              name: String(x.name || ""),
              avatar: String(x.avatar || ""),
              priority: Number(x.priority || 0),
              discount: Number(x.discount || 0)
            }))
            : [];
      } catch (e) {
        console.error(e);
        this.levelOptions = [];
      } finally {
        this.levelsLoading = false;
      }
    },
    openHistoryPreview(item) {
      if (!item) {
        this.showToast("warning", "خطا", "آیتم انتخاب شده معتبر نیست.");
        return;
      }
      this.selectedUserHistory = {
        fullName: item.fullName || "—",
        mobile: item.mobile || "—",
        levelName: item.levelName || "—",
        userId: item.userId || 0,
        levelLoyaltUserId: item.levelLoyaltUserId || 0
      };
      const mainItem =
          this.rawItems.find((rawItem) => rawItem.levelLoyaltUserId === item.levelLoyaltUserId) || item;
      this.userHistories = Array.isArray(mainItem.histories)
          ? mainItem.histories.map((history) => {
            const level = history?.levelLoyalt || {};
            return {
              levelLoyaltUserId: history.levelLoyaltUserId || 0,
              targetDate: history.targetDate || "",
              scheduleTotal: history.scheduleTotal || 0,
              groupClassTotal: history.groupClassTotal || 0,
              termicClassTotal: history.termicClassTotal || 0,
              supportTotal: history.supportTotal || 0,
              allTime: history.allTime || 0,
              levelName: level.name || "—",
              levelAvatar: level.avatar || ""
            };
          })
          : [];
      this.showHistoryModal = true;
    },
    openUpdateLevelModal(item) {
      if (!item) {
        this.showToast("danger", "خطا", "اطلاعات کاربر موجود نیست.");
        return;
      }
      const recId = Number(item.levelLoyaltUserId || 0);
      if (recId <= 0) {
        this.showToast("danger", "خطا", "شناسه رکورد معتبر نیست.");
        return;
      }
      this.selectedUserData = {
        levelLoyaltUserId: recId,
        userId: Number(item.userId || 0),
        fullName: item.fullName || "—",
        mobile: item.mobile || "—",
        levelId: Number(item.levelId || 0),
        levelName: item.levelName || "—",
        levelAvatar: item.levelAvatar || "",
        currentLevelId: Number(item.levelId || 0),
        currentLevelName: item.levelName || "—",
        currentLevelAvatar: item.levelAvatar || ""
      };
      this.showUpdateLevelModal = true;
    },
    handleLevelUpdated() {
      this.showUpdateLevelModal = false;
      this.selectedUserData = null;
      this.fetchList();
      this.showToast("success", "موفق", "اطلاعات سطح با موفقیت ویرایش شد.");
    },
    openCreateModal() {
      this.$bvModal.show("user-loyalty-create-modal");
      this.$nextTick(async () => {
        try {
          await Promise.allSettled([this.loadLevelsList(), this.loadUsersList("")]);
        } catch (error) {
          console.error("Error loading data:", error);
        }
      });
    },
    closeCreateModal() {
      this.$bvModal.hide("user-loyalty-create-modal");
    },
    handleUserSearch(searchValue, loadingFn) {
      if (this.usersSearchTimeout) clearTimeout(this.usersSearchTimeout);
      this.usersSearchTimeout = setTimeout(async () => {
        if (loadingFn) loadingFn(true);
        await this.loadUsersList(searchValue);
        if (loadingFn) loadingFn(false);
      }, 300);
    },
    async loadUsersList(searchValue = "") {
      try {
        const reqParams = { count: 10, pageNumber: 1 };
        const s = String(searchValue || "").trim();
        if (s) reqParams.fullname = s;
        const request = new GetAllUsersList(this);
        request.setRequestParamDataObj(reqParams);
        const response = await new Promise((resolve, reject) => {
          request.fetch((res) => (res?.isSuccess ? resolve(res) : reject(res)));
        });
        const users = response?.data?.users;
        this.usersList = Array.isArray(users) ? users : [];
      } catch (e) {
        console.error(e);
        this.usersList = [];
      }
    },
    async loadLevelsList() {
      try {
        const request = new GetLevelList(this);
        request.setRequestParam({ pageNumber: 1, count: 100 });
        const response = await new Promise((resolve, reject) => request.send(resolve, reject));
        const rows = response?.data?.data;
        this.levelsList = Array.isArray(rows)
            ? rows.map((level) => ({
              id: Number(level.id || 0),
              name: String(level.name || ""),
              avatar: String(level.avatar || ""),
              priority: Number(level.priority || 0),
              discount: Number(level.discount || 0)
            }))
            : [];
      } catch (e) {
        console.error(e);
        this.levelsList = [];
        this.showToast("danger", "خطا", "دریافت لیست سطوح انجام نشد");
      }
    },
    async submitCreate(payload) {
      try {
        this.isCreating = true;
        if (!payload.targetDate) {
          this.showToast("danger", "خطا", "تاریخ معتبر نیست");
          return;
        }
        const request = new CreatelevelLoyaltUserbyAdmin(this);
        request.setRequestParamDataObj({
          userId: Number(payload.userId || 0),
          levelLoyaltId: Number(payload.levelLoyaltId || 0),
          targetDate: payload.targetDate,
          description: String(payload.description || "")
        });
        const response = await new Promise((resolve, reject) => request.send(resolve, reject));
        if (!response || response.isSuccess === false) {
          throw new Error(response?.errors || "ثبت انجام نشد");
        }
        this.showToast("success", "موفق", "سطح وفاداری با موفقیت ثبت شد");
        this.closeCreateModal();
        this.fetchList();
      } catch (e) {
        console.error("Error in submitCreate:", e);
        const msg = e?.response?.data?.errors || e?.message || "ثبت انجام نشد";
        this.showToast("danger", "خطا", msg);
      } finally {
        this.isCreating = false;
      }
    },
    goToDetailPage(levelLoyaltUserId) {
      const id = this.normalizeUserId(levelLoyaltUserId);
      if (id <= 0) {
        this.showToast("danger", "خطا", "شناسه کاربر معتبر نیست.");
        return;
      }
      this.$router.push(`/apps/loyalty-level/getList/${id}`);
    },
    normalizeListResponse(response) {
      const root = response?.data ?? response ?? {};
      const dataLevel1 = root?.data;
      const dataLevel2 = root?.data?.data;
      const items =
          (Array.isArray(dataLevel2) && dataLevel2) ||
          (Array.isArray(dataLevel1) && dataLevel1) ||
          (Array.isArray(root) && root) ||
          [];
      const total = Number(root?.total ?? root?.data?.total ?? root?.data?.data?.total ?? items.length ?? 0) || 0;
      return { items, total };
    },
    async fetchList() {
      try {
        this.isLoading = true;

        const s = String(this.filters.search || "").trim();
        const pageNumber = Math.max(1, Number(this.filters.pageNumber || 1));
        const count = Math.max(1, Number(this.filters.count || 10));
        const levelId = Number(this.filters.levelLoyaltyId || 0);

        const request = new GetListLevelLoyaltUser(this);
        request.setRequestParam({
          pageNumber,
          count,
          search: s ? s : null,
          LevelLoyaltyId: levelId > 0 ? levelId : null
        });

        const response = await new Promise((resolve, reject) => request.send(resolve, reject));

        if (!response || response.isSuccess === false) {
          this.totalRows = 0;
          this.rawItems = [];
          this.showToast("danger", "خطا", response?.errors || "دریافت اطلاعات انجام نشد.");
          return;
        }

        const { items, total } = this.normalizeListResponse(response);
        this.totalRows = total;

        this.rawItems = items.map((item) => {
          const user = item?.user || {};
          const level = item?.levelLoyalt || item?.level || {};
          return {
            levelLoyaltUserId: Number(item.levelLoyaltUserId || 0),
            userId: Number(user.userId || 0),
            fullName: String(user.fullName || ""),
            mobile: String(user.mobile || ""),
            levelId: Number(item.levelId || 0),
            levelAvatar: String(level.avatar || ""),
            levelName: String(level.name || ""),
            targetDate: String(item.targetDate || ""),
            scheduleTotal: Number(item.scheduleTotal || 0),
            groupClassTotal: Number(item.groupClassTotal || 0),
            termicClassTotal: Number(item.termicClassTotal || 0),
            supportTotal: Number(item.supportTotal || 0),
            allTime: Number(item.allTime || 0),
            histories: Array.isArray(item.historys) ? item.historys : []
          };
        });
      } catch (e) {
        console.error(e);
        this.totalRows = 0;
        this.rawItems = [];
        this.showToast("danger", "خطا", "خطا در ارتباط با سرور");
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.avatar-cell {
  display: flex;
  align-items: center;
  gap: 10px;
  direction: rtl;
}
.avatar-text__title {
  font-weight: 900;
  font-size: 13px;
  color: #111827;
}
.avatar-text__subtitle {
  font-weight: 800;
  font-size: 11px;
  color: #6b7280;
  margin-top: 2px;
}
.actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.icon-btn {
  width: 38px;
  height: 38px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid #e5e7eb;
  background: #fff;
  transition: all 0.2s ease;
}
.icon-btn:hover:not(:disabled) {
  background: #f9fafb;
  border-color: #d1d5db;
  transform: translateY(-1px);
}
.lvl-option {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.lvl-option__info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.lvl-option__name {
  font-size: 13px;
  font-weight: 900;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.lvl-option__meta {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.meta-pill {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 999px;
  background: rgba(107, 114, 128, 0.1);
  font-size: 11px;
  font-weight: 900;
  color: #374151;
  white-space: nowrap;
}
.meta-pill--green {
  background: rgba(22, 163, 74, 0.12);
  color: #166534;
}
.lvl-selected {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.lvl-selected__name {
  font-size: 13px;
  font-weight: 900;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 240px;
}
.lvl-badge {
  width: 40px;
  height: 40px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.lvl-badge--sm {
  width: 28px;
  height: 28px;
  border-radius: 10px;
  box-shadow: none;
}
.lvl-img {
  width: 22px;
  height: 22px;
  object-fit: contain;
}
.lvl-img--sm {
  width: 16px;
  height: 16px;
}
</style>
